module.exports = __webpack_public_path__ + "static/media/razbijena-casa-1.bf0ecdea.svg";